import { getCheckoutProductDetails } from '../../products/product.helper'

// price added to support coming from payment intent - should not be like this, maybe a priceId and fetch from somewhere?
export const OrderCheckoutProduct = ({ productId }: { productId: string }): JSX.Element =>
  getCheckoutProductDetails(productId) ?? <></>
